import { requestGet, requestPost } from '@/utils/request'

export function getAccountList(params){
  return requestGet('/person/account/list', params);
}
export function getAccountListPage(params){
  return requestPost(`/person/account/listPage?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, params);
}
export function getAccountInfo(accountId){
  return requestGet('/person/account/' + accountId);
}
export function saveAccount(params){
  return requestPost('/person/account',params);
}
export function deleteAccount(accountId){
  return requestGet('/person/account/remove/' + accountId);
}
export function decodePassword(encodeStr){
  return requestGet('/person/account/decode/' + encodeStr);
}
